module.exports = __webpack_public_path__ + "img/chat-white.e2ef46f4.svg";